import React from 'react';
import ReactMarkdown from 'react-markdown';
import { VerificationQuestion as VerificationQuestionType } from 'types/verification.types';
import Icon from 'components/atoms/Icon';

interface VerificationQuestionProps {
  question: VerificationQuestionType;
}

const VerificationQuestion: React.FC<VerificationQuestionProps> = ({ question }) => {
  // Check if using new structured format or old markdown format
  const isStructuredFormat = question.sections && question.sections.length > 0;

  if (!isStructuredFormat && question.message) {
    // Fallback to markdown rendering for backward compatibility
    return (
      <div className="space-y-4">
        <div className="prose prose-sm max-w-none">
          <ReactMarkdown>{question.message}</ReactMarkdown>
        </div>
      </div>
    );
  }

  // Flatten all fields from all sections into a numbered list
  const allFields = question.sections.flatMap(section =>
    section.fields.map(field => ({
      name: field.field_name.replace(/_/g, ' '),
      value: field.value !== null && field.value !== undefined ? String(field.value) : 'N/A'
    }))
  );

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h2 className="text-base font-semibold text-gray-900 mb-3">Extracted Data Review</h2>
      </div>

      {/* Simple numbered list */}
      <ol className="list-decimal list-inside space-y-1 text-sm text-gray-900">
        {allFields.map((field, index) => (
          <li key={`field-${index}`}>
            <strong>{field.name}:</strong> {field.value}
          </li>
        ))}
      </ol>

      {/* Instructions */}
      {question.instructions && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-2">
            <Icon name="information-circle" className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
            <div className="space-y-2 text-sm">
              <p className="font-semibold text-blue-900">Next Steps:</p>
              <ul className="list-disc list-inside space-y-1 text-blue-800">
                <li>
                  Is this product information correct? If "Yes", select "Run Classification"
                </li>
                <li>
                  If the product information is incorrect, provide details below and select "Edit Product Info"
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerificationQuestion;
